module.exports = __webpack_public_path__ + "img/border-top.7045bae3.svg";